var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feedback-tile" },
    [
      _c("h2", { staticClass: "feedback-tile__title" }, [
        _vm._v(_vm._s(_vm.content.heading))
      ]),
      _c("p", { staticClass: "feedback-tile__caption" }, [
        _vm._v(_vm._s(_vm.content.caption))
      ]),
      _vm.content.button
        ? _c(
            "btn",
            {
              staticClass: "btn btn--primary feedback-tile__btn",
              attrs: {
                tag: "link",
                prevent: true,
                link: "/" + _vm.content.button.link
              },
              nativeOn: {
                click: function($event) {
                  return _vm.openOverlay($event)
                }
              }
            },
            [
              _vm._v("\n\t\t" + _vm._s(_vm.content.button.title) + "\n\n\t\t"),
              _c("icon-arrow", { staticClass: "feedback-tile__btn-icon" })
            ],
            1
          )
        : _vm._e(),
      _c(
        "page-overlay",
        {
          attrs: { show: _vm.overlayIsShow, width: 588, "auto-height": true },
          on: { close: _vm.closeOverlay }
        },
        [
          _c("h3", { staticClass: "feedback-tile__form-title" }, [
            _vm._v(_vm._s(_vm.content.form.title))
          ]),
          _vm.content.form
            ? _c("feedback-form", {
                attrs: {
                  content: _vm.content.form,
                  clear: _vm.formIsClear,
                  action: "/form/feedback",
                  ya_metrica_goal: _vm.ya_metrica_goal
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1921f52e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1921f52e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FeedbackTile.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1921f52e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FeedbackTile.vue
// module chunks = 0 1 2